import { render, staticRenderFns } from "./IntegralGoodList.vue?vue&type=template&id=c6bf6f20&scoped=true"
import script from "./IntegralGoodList.vue?vue&type=script&lang=js"
export * from "./IntegralGoodList.vue?vue&type=script&lang=js"
import style0 from "./IntegralGoodList.vue?vue&type=style&index=0&id=c6bf6f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bf6f20",
  null
  
)

export default component.exports